import { CONSENT_ELEMENT_TYPES } from './consent_element_types.constants';
/**
 * Figma WIZ-3 add-element chips (nodes 463:14561 / 463:14714).
 * Labels come from the catalog so the palette and inspector stay on the generic names (Date, Text).
 */
export const PLACEMENT_CHIPS = [
    { type: 'SIGNATURE', glyph: '✎' },
    { type: 'INITIALS', glyph: 'AB' },
    { type: 'MULTI_SELECT', glyph: '☐' },
    { type: 'SINGLE_SELECT', glyph: '◉' },
    { type: 'DATE_INPUT', glyph: '31' },
    { type: 'TEXT_INPUT', glyph: 'Aa' },
].map((chip) => ({
    ...chip,
    label: CONSENT_ELEMENT_TYPES[chip.type].label,
}));
export const ROLE_SWATCH = {
    'participant': '#4F46E5',
    'third party': '#15803D',
    'internal signer': '#CA8A04',
};
export const roleSwatchColor = (signerTypeId) => ROLE_SWATCH[signerTypeId ?? ''] ?? '#6B7280';
